import React, { useState, useEffect, useMemo } from "react";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import Loader from "../../../components/Loader";
import CommercialActivitiesTab from "./CommercialActivitiesTab";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const CommercialActivities = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const [activeTab, setActiveTab] = useState("");
  // const [lastUpdated, setLastUpdated] = useState("");

  const { data: commercialActivitiesHtml = [], isLoading: noticeIsLoading } =
    useGetProtectedApiDataQuery({
      url: "commercial_activities",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(commercialActivitiesHtml);
  }, [commercialActivitiesHtml]);

  useEffect(() => {
    if (commercialActivitiesHtml.length > 0) {
      const lastElement =
        commercialActivitiesHtml[commercialActivitiesHtml.length - 1];
      setActiveTab(lastElement.title);
    }
  }, [commercialActivitiesHtml, languageType]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (noticeIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Commercial", "वाणिज्यिक")}
        titleLink="/commercial/commercial-activities"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container power-section">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {commercialActivitiesHtml
                      .slice()
                      .reverse()
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                            }}
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            ></div>
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9 print-right">
                {commercialActivitiesHtml.map(
                  (item, index) =>
                    activeTab === item.title && (
                      <CommercialActivitiesTab key={index} data={item} />
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommercialActivities;
